import { useOption } from '@hooks/useOption';
import type { IL10n } from '@type/index';

const NoData = ({ l10n }: { l10n: IL10n }) => {
  const { serviceAlias } = useOption() || {};

  return (
    <div className="schedule-nodata-wrap">
      <div className="schedule-nodata">
        <span className="schedule-nodata-character"></span>
        <p className="schedule-nodata-text">{l10n?.content[`${serviceAlias}NoData`]}</p>
      </div>
    </div>
  );
};

export default NoData;
